import { Typography } from '@mui/material';
import styled from 'styled-components';

const Title = styled(Typography)`
  && {
    font-family: 'Poppins';
    font-weight: 600;
    font-size: 14px;
  }
`;

const Mark = styled(Typography)`
  && {
    font-size: 14px;
  }
`;

const ChartWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export { Mark,
  Title,
  ChartWrapper };
